import { graphql } from "@acto/gql";
import { useQuery } from "urql";

const NotesCountQuery = graphql(`
  query GetNotesCount($clientId: ID!, $dateRange: DateRangeInput) {
    notesCount(clientId: $clientId, dateRange: $dateRange)
  }
`);

interface NotesCountOptions {
  clientId: string;
  dateRange?: { startDate: string; endDate: string };
}

/** The total is independent of how many list pages the caller has fetched. */
export function useNotesCount({ clientId, dateRange }: NotesCountOptions): {
  count: number | undefined;
  isFetching: boolean;
  error: ReturnType<typeof useQuery>[0]["error"];
} {
  const [result] = useQuery({
    query: NotesCountQuery,
    variables: { clientId, dateRange },
    requestPolicy: "cache-and-network",
    pause: clientId.length === 0,
  });

  const { data, fetching: isFetching, error } = result;

  return {
    count: data?.notesCount,
    isFetching,
    error,
  };
}
